import moment from "moment";

const getSelectProperty = () => {
  const selectProperty = localStorage.getItem("selectProperty")
    ? JSON.parse(localStorage.getItem("selectProperty"))
    : null;
  return selectProperty;
};
const InitialState = {
  selectProperty: getSelectProperty(),
};

const SelectPropertyReducer = (state = InitialState, action) => {
  if (action.type === "Select_Property") {
    const newState = {
      selectProperty: action.payload,
    };

    localStorage.setItem("selectProperty", JSON.stringify(action.payload));

    return newState;
  }

  //logout
  else if (action.type === "Remove_User") {
    const newState = {
      selectProperty: null,
    };

    localStorage.removeItem("selectProperty");
    return newState;
  }

  return state;
};

export default SelectPropertyReducer;
